import { Col, DatePicker, Input, Row, Select } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { convertDateFromUTC } from './../../../../../services/dst';
import { dateFormat } from './../../../../../services/ruleValidate';
import { listChannel } from './../../../../../utils/channel'
import hanldeException from './../../../../../services/handleException';
import moment from "moment";
import './styles.css'
import { FulfillOption as FulfillOptionConst } from './../../../../../constants';
import Storage from '../../../../../services/Storage';
const Option = Select.Option 

class OrderInformation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listChannel: []
        }
    }

    componentDidMount() {
        this.loadChannel()
    }

    loadChannel = () => {
        let that = this;
        listChannel().then(res => {
            if (res.data.code === 10001) {
                let listChannel = res.data.data.channels
                that.setState({
                    listChannel: listChannel
                })
            } else {
                hanldeException(res)
            }
        }).catch(err => {
            hanldeException(err)
        })
    }

    renderListChannel = () => {
        return this.state.listChannel.map((e, i) => {
            return <Option value={JSON.stringify(e)} key={i + e.ID}>{e.Name}</Option>
        })
    }
    render() {
        const { shipment } = this.props
        const FulfillmentFlg = parseInt(Storage.get('FulfillmentFlg'))
        return (
            <div>
                <div id='order-information-1'>
                    <Row gutter={8} className="row-detailShipment">
                        <Col xl={{ span: 24 }}>
                            <div className="gutter-box item-row-detail-shipment">
                                <h3 id="title" className='title-field-1'>LAST UPDATE:</h3>
                            </div>
                            <div id="time" className='show-last-update item-row-detail-shipment'>
                                {shipment.LastUpdateDT ? moment(convertDateFromUTC(shipment.LastUpdateDT)).format(dateFormat) : ''}
                            </div>
                            <div className="gutter-box item-row-detail-shipment">
                                <h3 id="title" className='title-field-1'>BY</h3>
                            </div>
                            <div id="time" className='show-last-update item-row-detail-shipment'>
                                {shipment.LogNameCH}
                            </div>
                        </Col>
                    </Row>
                </div>
                <div id='order-information'>
                    <Row gutter={8}>
                        <Col span={24}>
                            <Row gutter={16} className="box-title-order-information">
                                <Col span={4}>
                                    <div className="gutter-box">
                                        <h3 className='title-field'>CHANNEL</h3>
                                        <Select
                                            style={{ width: '100%' }}
                                            defaultValue="amazon"
                                            value={shipment.ChannelName}
                                            disabled
                                        >
                                            {this.renderListChannel()}
                                        </Select>
                                    </div>
                                </Col>
                                <Col span={4}>
                                    <div className="gutter-box">
                                        <h3 className='title-field'>CHANNEL ORDER #</h3>
                                        <Input
                                            value={shipment.ChannelOrderID}
                                            disabled
                                        />
                                    </div>
                                </Col>
                                <Col span={4}>
                                    <div className="gutter-box order-date">
                                        <h3 className='title-field'>SHIP DATE</h3>
                                        <DatePicker
                                            style={{ width: '100%' }}
                                            format={dateFormat}
                                            allowClear={false}
                                            disabled
                                            value={shipment.ShipDateCH ? convertDateFromUTC(shipment.ShipDateCH) : null}
                                        />
                                    </div>
                                </Col>
                                <Col span={5}>
                                    <div className="gutter-box">
                                        <h3 className='title-field'>REF #</h3>
                                        <Input
                                            placeholder="REF #"
                                            value={shipment.ReferenceNumberCH}
                                            disabled
                                        />
                                    </div>
                                </Col>
                                { 
                                    FulfillmentFlg ?  
                                    <Col span={4}>
                                        <div className="gutter-box">
                                            <h3 className='title-field'>Fulfillment Option</h3>
                                            <Select 
                                                disabled
                                                value={shipment.FulfillmentOption}
                                                className="select-fulfillment-option-box">
                                                <Option value={FulfillOptionConst.YAMATO.CODE}>{FulfillOptionConst.YAMATO.NAME}</Option>
                                                <Option value={FulfillOptionConst.IN_HOUSE.CODE}>{FulfillOptionConst.IN_HOUSE.NAME}</Option>
                                            </Select>
                                        </div>
                                    </Col>
                                    : ''
                                } 
                                
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        shipment: state.detailShipment.shipment
    }
}

export default connect(
    mapStateToProps,
)(OrderInformation)



// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/components/order-information/index.js